'use strict';
import {reduxList as assetReqList} from '../redux/assetReqList';
import {
  assetFileRequirementReduxItem,
  assetFileRequirementRouterState,
} from '../redux/files/assetFileRequirementRouterState';
import {createAssetFileRequirementRequestModal} from '../redux/files/createAssetFileRequirement';
import {createProjectFileRequirementRequestModal} from '../redux/files/createProjectFileRequirement';
import {createTemplateFileRequirementRequestModal} from '../redux/files/createTemplateFileRequirement';
import {
  projectFileRequirementReduxItem,
  projectFileRequirementRouterState,
} from '../redux/files/projectFileRequirementRouterState';
import {updateAssetFileRequirementRequestModal} from '../redux/files/updateAssetFileRequirement';
import {updateProjectFileRequirementRequestModal} from '../redux/files/updateProjectFileRequirement';
import {updateTemplateFileRequirementRequestModal} from '../redux/files/updateTemplateFileRequirement';
import {
  assetFormRequirementReduxItem,
  assetFormRequirementRouterState,
} from '../redux/forms/assetFormRequirementRouterState';
import {createAssetFormRequirementRequestModal} from '../redux/forms/createAssetFormRequirement';
import {createProjectFormRequirementRequestModal} from '../redux/forms/createProjectFormRequirement';
import {createTemplateFormRequirementRequestModal} from '../redux/forms/createTemplateFormRequirement';
import {
  projectFormRequirementReduxItem,
  projectFormRequirementRouterState,
} from '../redux/forms/projectFormRequirementRouterState';
import {updateAssetFormReqResponseReduxRequest} from '../redux/forms/updateAssetFormReqResponse';
import {updateAssetFormRequirementRequestModal} from '../redux/forms/updateAssetFormRequirement';
import {updateProjectFormReqResponseReduxRequest} from '../redux/forms/updateProjectFormReqResponse';
import {updateProjectFormRequirementRequestModal} from '../redux/forms/updateProjectFormRequirement';
import {updateTemplateFormRequirementRequestModal} from '../redux/forms/updateTemplateFormRequirement';
import {reduxList as assetReqFilesList} from '../redux/fulfillments/assetReqFilesList';
import {reduxList as projectReqFilesList} from '../redux/fulfillments/projectReqFilesList';
import {reduxList as projectReqList} from '../redux/projectReqList';
import {reduxList as templateReqList} from '../redux/templateReqList';
import {epics as infoModalEpic} from './infoModalEpic';


export const epics = [
  ...assetFileRequirementReduxItem.epics.epics,
  ...assetFileRequirementRouterState.epics.epics,
  ...assetFormRequirementReduxItem.epics.epics,
  ...assetFormRequirementRouterState.epics.epics,
  ...assetReqFilesList.epics.epics,
  ...assetReqList.epics.epics,
  ...projectFileRequirementReduxItem.epics.epics,
  ...projectFileRequirementRouterState.epics.epics,
  ...projectFormRequirementReduxItem.epics.epics,
  ...projectFormRequirementRouterState.epics.epics,
  ...projectReqFilesList.epics.epics,
  ...projectReqList.epics.epics,
  ...templateReqList.epics.epics,
  ...infoModalEpic,
  ...createAssetFormRequirementRequestModal.epics.epics,
  ...createProjectFormRequirementRequestModal.epics.epics,
  ...createTemplateFormRequirementRequestModal.epics.epics,
  ...createAssetFileRequirementRequestModal.epics.epics,
  ...createProjectFileRequirementRequestModal.epics.epics,
  ...createTemplateFileRequirementRequestModal.epics.epics,
  ...updateAssetFormRequirementRequestModal.epics.epics,
  ...updateProjectFormRequirementRequestModal.epics.epics,
  ...updateTemplateFormRequirementRequestModal.epics.epics,
  ...updateAssetFileRequirementRequestModal.epics.epics,
  ...updateProjectFileRequirementRequestModal.epics.epics,
  ...updateTemplateFileRequirementRequestModal.epics.epics,
  ...updateAssetFormReqResponseReduxRequest.epics.epics,
  ...updateProjectFormReqResponseReduxRequest.epics.epics,
];



// WEBPACK FOOTER //
// ./src/js/requirements/epics/index.js